// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tree-dragnode {
  padding: 10px;
  border: 1px solid #e7eef7;
  position: fixed;
  border-radius: 8px;
  background: #fff;
  transform: translate(-50%, -110%);
  z-index: 10;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vls-liquor-tree/src/components/DraggableNode.vue"],"names":[],"mappings":";AAqCA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,WAAA;AACA","sourcesContent":["<template>\n  <div\n    class=\"tree-dragnode\"\n    :style=\"style\"\n  >\n    {{ target.node.text }}\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'DragNode',\n    props: ['target'],\n    computed: {\n      style() {\n        if (undefined === this.target.top) {\n          return 'display: none'\n        }\n\n        return `top: ${this.target.top}px; left: ${this.target.left}px`\n      }\n    }\n  }\n</script>\n\n<style>\n  .tree-dragnode {\n    padding: 10px;\n    border: 1px solid #e7eef7;\n    position: fixed;\n    border-radius: 8px;\n    background: #fff;\n    transform: translate(-50%, -110%);\n    z-index: 10;\n  }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
